/* global __webpack_hash__ */

// see https://getbootstrap.com/docs/4.6/getting-started/webpack/#importing-compiled-css
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import NProgress from 'nprogress'
import { setRpcapi } from '~vueutil/pinia.js'
import { RedirectedError } from '~vueutil/router.js'
import { getHydratePinia } from '../../pinia/hydrate.js'
import { createApp } from '../../app.js'

import { createRpcapi } from '../../store/rpc/create.js'
import { createWebRouter } from '../../router.js'

NProgress.start()

const main = async function () {
  const appId = `#_${__webpack_hash__}`

  const pinia = getHydratePinia(window)
  const rpcapi = createRpcapi('/')
  setRpcapi(pinia, rpcapi)

  const router = createWebRouter()

  const app = createApp()
    .use(pinia)
    .use(router)

  await router.isReady()
  app.mount(appId)

  NProgress.done()
}

;(async function () {
  try {
    main()
  } catch (err) {
    if (err instanceof RedirectedError) {
      window.location.href = err.redirectTo
      return
    }
    console.log(err)
  }
})()
